import React from 'react'
import PropTypes from 'prop-types'
import { semantic } from '@lexody/design-tokens'

import Icon from '../app_components/Icon'
import {
  PROFILE_COMPLETION_ITEMS,
  getIncompleteProfileItems,
} from './profileCompletionHelpers'

class ProfileCompletionChecklist extends React.Component {
  renderItem(item) {
    const isComplete = !this.props.profileCompletion[item.key]

    return (
      <li key={item.key} className="profileCompletionChecklist__item">
        <div className="profileCompletionChecklist__itemCopy">
          <p className="profileCompletionChecklist__itemLabel">{item.label}</p>
          {item.description && (
            <p className="profileCompletionChecklist__itemDescription">{item.description}</p>
          )}
        </div>
        <div className="profileCompletionChecklist__itemAction">
          {isComplete ? (
            <span
              className="profileCompletionChecklist__check"
              aria-label={`${item.label} complete`}
            >
              <Icon
                name="check"
                size={16}
                color={semantic.greyscale.text.negative}
              />
            </span>
          ) : (
            <button
              type="button"
              className="small_button_secondary profileCompletionChecklist__updateButton"
              onClick={() => window.location.assign(item.href)}
            >
              Update
            </button>
          )}
        </div>
      </li>
    )
  }

  render() {
    const incompleteItems = getIncompleteProfileItems(this.props.profileCompletion)
    const completedCount = PROFILE_COMPLETION_ITEMS.length - incompleteItems.length

    return (
      <div className="profileCompletionChecklist">
        <p className="profileCompletionChecklist__lead">
          Complete your profile to start connecting with language partners.
        </p>
        <p className="profileCompletionChecklist__progress">
          {completedCount} of {PROFILE_COMPLETION_ITEMS.length} complete
        </p>
        <ul className="profileCompletionChecklist__list">
          {PROFILE_COMPLETION_ITEMS.map((item) => this.renderItem(item))}
        </ul>
      </div>
    )
  }
}

ProfileCompletionChecklist.propTypes = {
  profileCompletion: PropTypes.shape({
    birthday: PropTypes.bool,
    location: PropTypes.bool,
    native_language: PropTypes.bool,
    learning_language: PropTypes.bool,
    incomplete: PropTypes.bool,
  }).isRequired,
}

export default ProfileCompletionChecklist
